export default [
  { key: 'audio-guide', icon: '' },
  { key: 'elearning', icon: '' },
  { key: 'video-presentation-product-video', icon: '' },
  { key: 'technology', icon: '' },
  { key: 'tv-narrator-documentary', icon: '' },
  { key: 'commercial', icon: '' },
  { key: 'gaming', icon: '' },
  { key: 'event-presentation-internal', icon: '' },
  { key: 'ivr', icon: '' },
  { key: 'podcast', icon: '' },
  { key: 'character', icon: '' },
]
